/**
 * @generated SignedSource<<0d9c4ba6f8060356383ee7ef991bc550>>
 * @relayHash c45a58669362a3c85866cac701b5a642
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83f3ba61fe829555428381b30948e222f0fa214183b6fb62734be44b36705042

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceApprovalExpirationIntervalUnit = "MONTH" | "WEEK" | "YEAR" | "%future added value";
export type ConfluenceApprovalTransitionType = "DIRECTED" | "INITIAL" | "%future added value";
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type ConfluenceReviewerDecisionState = "PENDING_REVIEW" | "REVIEWER_APPROVED" | "REVIEWER_DENIED" | "REVIEW_CANCELED" | "%future added value";
export type ConfluenceWorkflowReviewStatus = "APPROVED" | "CANCELED" | "DENIED" | "PENDING" | "%future added value";
export type ApprovalsContextApprovalsDataQuery$variables = {
  cloudId: string;
  contentId: string;
  contentStatus: string;
  includeApprovalExpirationConfig: boolean;
  includeApprovalsBetaFeatures: boolean;
  otherContentStatus: string;
  spaceKey: string;
  transitionType?: ConfluenceApprovalTransitionType | null;
};
export type ApprovalsContextApprovalsDataQuery$data = {
  readonly confluence_contentApprovalStatuses: ReadonlyArray<{
    readonly allowsReviews: boolean | null;
    readonly displayProperties: {
      readonly color: string | null;
      readonly name: string | null;
    } | null;
    readonly id: string | null;
  } | null> | null;
  readonly confluence_contentApprovalsSiteSettings?: {
    readonly enabled: boolean;
  } | null;
  readonly confluence_contentApprovalsSpaceSettingConfig?: {
    readonly config: {
      readonly approvalExpirationConfig?: {
        readonly interval: {
          readonly unit: ConfluenceApprovalExpirationIntervalUnit;
          readonly value: number;
        } | null;
        readonly isEnabled: boolean;
      };
      readonly disallowFirstPublish: boolean;
      readonly enforcedApprovalReviewerConfig: {
        readonly isEnabled: boolean;
        readonly reviewers: ReadonlyArray<{
          readonly principalId: string;
          readonly principalType: ConfluencePrincipalType;
          readonly user: {
            readonly displayName: string | null;
            readonly id: string | null;
            readonly isActive: boolean | null;
            readonly photos: ReadonlyArray<{
              readonly isPrimary: boolean | null;
              readonly value: string | null;
            } | null> | null;
          } | null;
        } | null>;
      };
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }>;
    readonly success: boolean;
  } | null;
  readonly confluence_getActiveWorkflowApplication: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }>;
    readonly success: boolean;
    readonly workflowApplication: {
      readonly contentId: string | null;
      readonly contentStatus: string | null;
      readonly contentVersion: number | null;
      readonly creator: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly isActive: boolean | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly id: string | null;
      readonly isActive: boolean | null;
      readonly lastModificationDate: {
        readonly value: string;
      } | null;
      readonly modifier: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly isActive: boolean | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly workflowId: string | null;
      readonly workflowStatusId: string | null;
    } | null;
    readonly workflowReviewWithDecisions: {
      readonly creationDate: {
        readonly value: string;
      } | null;
      readonly creator: {
        readonly displayName: string | null;
        readonly id: string | null;
        readonly isActive: boolean | null;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly creatorAaid: string | null;
      readonly dueDate?: {
        readonly value: string;
      } | null;
      readonly id: string;
      readonly reviewComment: string | null;
      readonly reviewLastModified: {
        readonly value: string;
      } | null;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
      readonly reviewerDecisions: ReadonlyArray<{
        readonly comment: string | null;
        readonly decisionId: string | null;
        readonly lastModifiedDate: {
          readonly value: string;
        } | null;
        readonly principalId: string;
        readonly principalType: ConfluencePrincipalType;
        readonly required: boolean | null;
        readonly reviewerDecisionStatus: ConfluenceReviewerDecisionState | null;
        readonly reviewerId: string | null;
        readonly user: {
          readonly displayName: string | null;
          readonly id: string | null;
          readonly isActive: boolean | null;
          readonly photos: ReadonlyArray<{
            readonly isPrimary: boolean | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
      } | null>;
    } | null;
  } | null;
  readonly confluence_getActiveWorkflowApplicationForOtherStatus: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }>;
    readonly success: boolean;
    readonly workflowReviewWithDecisions: {
      readonly id: string;
      readonly reviewStatus: ConfluenceWorkflowReviewStatus;
    } | null;
  } | null;
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly status: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly space: {
    readonly id: string | null;
    readonly spaceTypeSettings: {
      readonly enabledFeatures: {
        readonly isContentApprovalsEnabled: boolean | null;
      };
    };
  } | null;
};
export type ApprovalsContextApprovalsDataQuery = {
  response: ApprovalsContextApprovalsDataQuery$data;
  variables: ApprovalsContextApprovalsDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatus"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeApprovalExpirationConfig"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeApprovalsBetaFeatures"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "otherContentStatus"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transitionType"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "args": [
    {
      "kind": "Variable",
      "name": "key",
      "variableName": "spaceKey"
    }
  ],
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "concreteType": "SpaceTypeSettings",
      "kind": "LinkedField",
      "name": "spaceTypeSettings",
      "plural": false,
      "selections": [
        {
          "concreteType": "EnabledFeatures",
          "kind": "LinkedField",
          "name": "enabledFeatures",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isContentApprovalsEnabled"
            }
          ]
        }
      ]
    }
  ]
},
v10 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v11 = {
  "kind": "ScalarField",
  "name": "success"
},
v12 = {
  "kind": "ScalarField",
  "name": "message"
},
v13 = {
  "kind": "ScalarField",
  "name": "isEnabled"
},
v14 = {
  "kind": "ScalarField",
  "name": "value"
},
v15 = {
  "kind": "ScalarField",
  "name": "principalType"
},
v16 = {
  "kind": "ScalarField",
  "name": "principalId"
},
v17 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v18 = {
  "kind": "ScalarField",
  "name": "isActive"
},
v19 = {
  "kind": "ScalarField",
  "name": "isPrimary"
},
v20 = [
  (v8/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  {
    "concreteType": "AtlassianUserPhoto",
    "kind": "LinkedField",
    "name": "photos",
    "plural": true,
    "selections": [
      (v14/*: any*/),
      (v19/*: any*/)
    ]
  }
],
v21 = {
  "condition": "includeApprovalsBetaFeatures",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        (v10/*: any*/)
      ],
      "concreteType": "ConfluenceContentApprovalsSiteSettings",
      "kind": "LinkedField",
      "name": "confluence_contentApprovalsSiteSettings",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "enabled"
        }
      ]
    },
    {
      "args": [
        (v10/*: any*/),
        {
          "kind": "Literal",
          "name": "filterSelf",
          "value": false
        },
        {
          "kind": "Variable",
          "name": "spaceKey",
          "variableName": "spaceKey"
        }
      ],
      "concreteType": "ConfluenceContentApprovalsSpaceSettingConfigPayload",
      "kind": "LinkedField",
      "name": "confluence_contentApprovalsSpaceSettingConfig",
      "plural": false,
      "selections": [
        (v11/*: any*/),
        {
          "concreteType": "MutationError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": [
            (v12/*: any*/)
          ]
        },
        {
          "concreteType": "ConfluenceContentApprovalsSpaceSettingConfig",
          "kind": "LinkedField",
          "name": "config",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "disallowFirstPublish"
            },
            {
              "condition": "includeApprovalExpirationConfig",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "ConfluenceApprovalExpirationConfig",
                  "kind": "LinkedField",
                  "name": "approvalExpirationConfig",
                  "plural": false,
                  "selections": [
                    (v13/*: any*/),
                    {
                      "concreteType": "ConfluenceApprovalExpirationInterval",
                      "kind": "LinkedField",
                      "name": "interval",
                      "plural": false,
                      "selections": [
                        (v14/*: any*/),
                        {
                          "kind": "ScalarField",
                          "name": "unit"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "concreteType": "ConfluenceApprovalReviewerConfig",
              "kind": "LinkedField",
              "name": "enforcedApprovalReviewerConfig",
              "plural": false,
              "selections": [
                (v13/*: any*/),
                {
                  "concreteType": "ConfluenceSpaceApprovalReviewerEntry",
                  "kind": "LinkedField",
                  "name": "reviewers",
                  "plural": true,
                  "selections": [
                    (v15/*: any*/),
                    (v16/*: any*/),
                    {
                      "concreteType": "AtlassianUser",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": (v20/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v22 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v23 = {
  "kind": "ScalarField",
  "name": "status"
},
v24 = {
  "concreteType": "Version",
  "kind": "LinkedField",
  "name": "version",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ]
},
v25 = {
  "args": [
    (v10/*: any*/),
    {
      "kind": "Variable",
      "name": "transitionType",
      "variableName": "transitionType"
    }
  ],
  "concreteType": "ConfluenceApprovalsWorkflowStatus",
  "kind": "LinkedField",
  "name": "confluence_contentApprovalStatuses",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "allowsReviews"
    },
    {
      "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
      "kind": "LinkedField",
      "name": "displayProperties",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "color"
        }
      ]
    }
  ]
},
v26 = {
  "kind": "Variable",
  "name": "contentId",
  "variableName": "contentId"
},
v27 = {
  "kind": "Literal",
  "name": "fetchWorkflowReview",
  "value": true
},
v28 = {
  "kind": "Literal",
  "name": "workflowId",
  "value": "1"
},
v29 = [
  (v10/*: any*/),
  (v26/*: any*/),
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "otherContentStatus"
  },
  (v27/*: any*/),
  (v28/*: any*/)
],
v30 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v31 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v32 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        (v30/*: any*/),
        (v31/*: any*/)
      ]
    }
  ]
},
v33 = {
  "kind": "ScalarField",
  "name": "reviewStatus"
},
v34 = {
  "concreteType": "ConfluenceWorkflowReviewWithDecisions",
  "kind": "LinkedField",
  "name": "workflowReviewWithDecisions",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v33/*: any*/)
  ]
},
v35 = [
  (v10/*: any*/),
  (v26/*: any*/),
  {
    "kind": "Variable",
    "name": "contentStatus",
    "variableName": "contentStatus"
  },
  (v27/*: any*/),
  (v28/*: any*/)
],
v36 = {
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v20/*: any*/)
},
v37 = [
  (v14/*: any*/)
],
v38 = {
  "concreteType": "ConfluenceWorkflowApplicationDetails",
  "kind": "LinkedField",
  "name": "workflowApplication",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "workflowId"
    },
    {
      "kind": "ScalarField",
      "name": "contentId"
    },
    {
      "kind": "ScalarField",
      "name": "contentVersion"
    },
    {
      "kind": "ScalarField",
      "name": "contentStatus"
    },
    {
      "kind": "ScalarField",
      "name": "workflowStatusId"
    },
    (v18/*: any*/),
    (v36/*: any*/),
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "lastModificationDate",
      "plural": false,
      "selections": (v37/*: any*/)
    },
    {
      "concreteType": "AtlassianUser",
      "kind": "LinkedField",
      "name": "modifier",
      "plural": false,
      "selections": (v20/*: any*/)
    }
  ]
},
v39 = {
  "concreteType": "ConfluenceWorkflowReviewWithDecisions",
  "kind": "LinkedField",
  "name": "workflowReviewWithDecisions",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "creatorAaid"
    },
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "creationDate",
      "plural": false,
      "selections": (v37/*: any*/)
    },
    (v33/*: any*/),
    {
      "kind": "ScalarField",
      "name": "reviewComment"
    },
    {
      "condition": "includeApprovalsBetaFeatures",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "ConfluenceApprovalsDate",
          "kind": "LinkedField",
          "name": "dueDate",
          "plural": false,
          "selections": (v37/*: any*/)
        }
      ]
    },
    {
      "concreteType": "ConfluenceApprovalsDate",
      "kind": "LinkedField",
      "name": "reviewLastModified",
      "plural": false,
      "selections": (v37/*: any*/)
    },
    (v36/*: any*/),
    {
      "concreteType": "ConfluenceReviewerDecisionInfo",
      "kind": "LinkedField",
      "name": "reviewerDecisions",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "decisionId"
        },
        {
          "kind": "ScalarField",
          "name": "reviewerId"
        },
        {
          "kind": "ScalarField",
          "name": "required"
        },
        (v15/*: any*/),
        (v16/*: any*/),
        {
          "kind": "ScalarField",
          "name": "reviewerDecisionStatus"
        },
        {
          "kind": "ScalarField",
          "name": "comment"
        },
        {
          "concreteType": "ConfluenceApprovalsDate",
          "kind": "LinkedField",
          "name": "lastModifiedDate",
          "plural": false,
          "selections": (v37/*: any*/)
        },
        {
          "concreteType": "AtlassianUser",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            (v8/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            {
              "concreteType": "AtlassianUserPhoto",
              "kind": "LinkedField",
              "name": "photos",
              "plural": true,
              "selections": [
                (v19/*: any*/),
                (v14/*: any*/)
              ]
            }
          ]
        }
      ]
    }
  ]
},
v40 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    {
      "kind": "LinkedField",
      "name": "extensions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        (v30/*: any*/),
        (v31/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v8/*: any*/)
          ],
          "type": "BulkMutationErrorExtension"
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ApprovalsContextApprovalsDataQuery",
    "selections": [
      (v9/*: any*/),
      (v21/*: any*/),
      {
        "args": (v22/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v23/*: any*/),
              (v24/*: any*/)
            ]
          }
        ]
      },
      (v25/*: any*/),
      {
        "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
        "args": (v29/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v32/*: any*/),
          (v34/*: any*/)
        ]
      },
      {
        "args": (v35/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v32/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "ApprovalsContextApprovalsDataQuery",
    "selections": [
      (v9/*: any*/),
      (v21/*: any*/),
      {
        "args": (v22/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v23/*: any*/),
              (v24/*: any*/),
              (v8/*: any*/)
            ]
          }
        ]
      },
      (v25/*: any*/),
      {
        "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
        "args": (v29/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v40/*: any*/),
          (v34/*: any*/)
        ]
      },
      {
        "args": (v35/*: any*/),
        "concreteType": "ConfluenceWorkflowApplicationPayload",
        "kind": "LinkedField",
        "name": "confluence_getActiveWorkflowApplication",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v40/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "c45a58669362a3c85866cac701b5a642",
    "id": "83f3ba61fe829555428381b30948e222f0fa214183b6fb62734be44b36705042",
    "metadata": {},
    "name": "ApprovalsContextApprovalsDataQuery",
    "operationKind": "query",
    "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!,$includeApprovalsBetaFeatures:Boolean!,$includeApprovalExpirationConfig:Boolean!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}}},confluence_contentApprovalsSiteSettings(cloudId:$cloudId)@include(if:$includeApprovalsBetaFeatures){enabled}\n  confluence_contentApprovalsSpaceSettingConfig(cloudId:$cloudId,spaceKey:$spaceKey,filterSelf:false)@include(if:$includeApprovalsBetaFeatures){success,errors{message},config{disallowFirstPublish,approvalExpirationConfig@include(if:$includeApprovalExpirationConfig){isEnabled,interval{value,unit}},enforcedApprovalReviewerConfig{isEnabled,reviewers{principalType,principalId,user{id,displayName,isActive,photos{value,isPrimary}}}}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,dueDate@include(if:$includeApprovalsBetaFeatures){value},reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
  }
};
})();

(node as any).hash = "a846539b419619ed532fbc92d54a619e";

export default node;
